import {CountryModel} from '@/models/country.model';
import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {BaseApi} from '@/api/base.api';
import {axiosInstance} from '@/api/axios.config.api';

export class CountryApi extends BaseApi<CountryModel> {
  constructor() {
    super('countries')
  }

  allTimezones(): Observable<string[]> {
    return axiosInstance().get<string[]>('timezones')
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }
}
